import { forwardRef } from 'react';
import type { ReactNode } from 'react';

import { visuallyHiddenClass } from './VisuallyHidden.css';
import { getClassNames } from '../../util/css';

type VisuallyHiddenProps = {
  children: ReactNode;
  id?: string;
  ariaLive?: 'polite' | 'assertive' | 'off';
  className?: string;
};

const sparkyVisuallyHiddenClassName = 'sparky-visually-hidden';

export const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenProps>(
  ({ children, id, ariaLive, className }, ref) => {
    const classNames = getClassNames(sparkyVisuallyHiddenClassName, visuallyHiddenClass, className);
    return (
      <span ref={ref} id={id} aria-live={ariaLive} className={classNames}>
        {children}
      </span>
    );
  },
);

VisuallyHidden.toString = () => `.${sparkyVisuallyHiddenClassName}`;
VisuallyHidden.displayName = 'VisuallyHidden';
